/**
 * @generated SignedSource<<304da78dfe2062d0c870c12402e77638>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type HelpLayoutConnectElementPages = "APPROVALS" | "CREATE_REQUEST" | "HELP_CENTER" | "MY_REQUEST" | "PORTAL" | "PROFILE" | "VIEW_REQUEST" | "%future added value";
export type HelpLayoutConnectElementType = "detailsPanels" | "footerPanels" | "headerAndSubheaderPanels" | "headerPanels" | "optionPanels" | "profilePagePanel" | "propertyPanels" | "requestCreatePanel" | "subheaderPanels" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type connectElementFragment$data = {
  readonly connectElementPage: HelpLayoutConnectElementPages;
  readonly connectElementType: HelpLayoutConnectElementType;
  readonly " $fragmentType": "connectElementFragment";
};
export type connectElementFragment$key = {
  readonly " $data"?: connectElementFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"connectElementFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "connectElementFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "connectElementPage"
    },
    {
      "kind": "ScalarField",
      "name": "connectElementType"
    }
  ],
  "type": "HelpLayoutConnectElement"
};

(node as any).hash = "88a04fa7e931050b52a2fe8d7668fe89";

export default node;
